"use strict";

exports.__esModule = true;
exports.default = void 0;

var _tooltip = _interopRequireDefault(require("./tooltip"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var directives = {
  BTooltip: _tooltip.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    directives: directives
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/directives/tooltip/index.js
// module id = 295
// module chunks = 43